import { useEffect, useRef, useState } from "react";
import { Pressable, ScrollView, StyleSheet, TextInput as ReactText, Switch, Text, TextInput, TouchableOpacity, View, Alert } from "react-native"
import { MyButton, TextInputTemp } from "./buttonsAndControls";
import { Checkbox, IconButton, Portal, Provider as PaperProvider, Modal } from "react-native-paper";
import React from "react";
import { DEBUG, enablePromise, openDatabase } from "react-native-sqlite-storage";
import { stopCodes } from "./StockAwareTempData";
import SingleDayDateSelect from "./SingleDayDateSelect";

const darkColour='#2a2d3e';

interface ExpensesChildData {
  id: number;
  texts: string[];
}
interface Expenses {
  ID: number;
  Date: string;
  Description: string;
  Expenses_Type: string;
  Amount: number;
};

interface Payments {
  ID: number;
  Payment_Method: string;
  After_Discount: number;
};

const ExpensesChild = ({ texts, onCheckboxChange, index, type, delPressed, isExpenses, showCheckBox
}: ExpensesChildData & { onCheckboxChange: (payment: number) => void; isExpenses: boolean; showCheckBox: boolean;
  index: number; type: string; delPressed: (() => void); }) => {

  const isEvenIndex = index % 2 === 0;
  const backgroundColor = isEvenIndex ? '#E6E6E6' : '#F5F5F5';
  const sizes: number[] = [485, 150, 150, 150];
	const [hovered, setHovered] = useState(false);
	const [isOpacity, setIsOpacity] = useState(false);
  const [checked, setChecked] = useState(1);

  useEffect(() => {
		if (stopCodes) {
			if (type === 'Cash') {
        setChecked(1)
      }else if (type === 'POS') {
        setChecked(2) 
      } else if (type === 'Bank transfer') {
        setChecked(3)
      } else {setChecked(1)}
    }
			setTimeout (() => {
			},200)
		},
  [stopCodes]);

  return (
    <View style={{ backgroundColor }}>
      <TouchableOpacity>
				<Pressable style={{... styles.childPressable, backgroundColor: hovered ? '#CCCCCC' : 'transparent', opacity: isOpacity ? 0.2 : 1}}
					onHoverIn={() => setHovered(true)}
					onHoverOut={() => setHovered(false)}
					onPressIn={() => setIsOpacity(true)}
					onPressOut={() => setIsOpacity(false)}
				>
        {texts.map((text, i) => (
          <View key={i}>
            {i > 0 || !isExpenses  ? 
            <View key={i} style={{...styles.paymentCheckBox, width: isExpenses ? sizes[i] : 200, justifyContent: !isExpenses || isExpenses && !showCheckBox ? 'center' : hovered ? 'space-between' : 'center' }}>
              {hovered && isExpenses && showCheckBox &&
              <Checkbox
                status={ checked === i ? 'checked' : 'unchecked' }
                color= {darkColour}
                onPress={() => {setChecked(i); onCheckboxChange(i)}}
              />
              }
              {checked === i && isExpenses &&
              <Text key={i} style={{...styles.textStyle, color: darkColour, marginRight: 10 }}>
                {text}
              </Text>
              }
              {checked === i + 1 && !isExpenses &&
              <Text key={i} style={{...styles.textStyle, color: darkColour, marginRight: 10 }}>
                {text}
              </Text>
              }
            </View>
            :
            <View key={i} style={{...styles.viewStyle, width: sizes[i]}}>
              <Text key={i} style={{...styles.textStyle, color: darkColour }}>
                {text}
              </Text>
            </View>
            }
          </View>
           
        ))}

        {hovered && isExpenses && showCheckBox &&
					<IconButton icon={'trash-can-outline'}size={25} focusable={false} iconColor={darkColour}  
					style={{justifyContent:'center', padding:0, margin:0, marginLeft: -5, alignContent:'center'}}
					onPress={() => delPressed()} />
				}
				</Pressable>
      </TouchableOpacity>
    </View>
  );
};

const TotalAndExpenses = () => {

	const [whoClicked, setWhoClicked] = useState('today')
	const [footerText, setFooterText] = useState('Showing from this month')
	const [checked, setChecked] = useState('Cash');
	const [dateVisible, setDateVisible] = useState(false);
	const [filteredResult, setFilteredResult] = useState<Expenses[]>([]);
  const [paymentsData, setPaymentsData] = useState<Payments[]>([]);
  const [cash, setCash] = useState(0);
  const [pOS, setPOS] = useState(0);
  const [bank, setBank] = useState(0);
  const [totalCash, setTotalCash] = useState(0);
  const [totalPOS, setTotalPOS] = useState(0);
  const [totalBank, setTotalBank] = useState(0);
  const qtyRef = useRef<ReactText>(null);
  const [descriptionText, setDescriptionText] = useState('')
  const [expAmount, setExpAmount] = useState('')
  const [addExpensesModal, setAddExpensesModal] = useState(false)
  const [allTotal, setAllTotal] = useState(0);
  const [allCashTotal, setAllCashTotal] = useState(0);
  const [allPOSTotal, setAllPOSTotal] = useState(0);
  const [allBankTotal, setAllBankTotal] = useState(0);
  const [allExpTotal, setAllExpTotal] = useState(0);
  const [allCashExpTotal, setAllCashExpTotal] = useState(0);
  const [allPOSExpTotal, setAllPOSExpTotal] = useState(0);
  const [allBankExpTotal, setAllBankExpTotal] = useState(0);
  const [allAfterExpTotal, setAllAfterExpTotal] = useState(0);

  const fetchExpenses = async (n: string, date: string) => {
		DEBUG(true);
		enablePromise(true);
		const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
    (await initDB).transaction((tx) => {
			tx.executeSql(
        `SELECT * FROM Expenses WHERE ${date ? date : `DATE(Date) = DATE('now', '-${n} days')`} ORDER BY ID DESC`,
        [],
        (_, results) => {
          const rows = results.rows;
          const expensesArray: Expenses[] = [];
          for (let i = 0; i < rows.length; i++) {
            expensesArray.push(rows.item(i) as Expenses);
          }
					setFilteredResult(expensesArray);
        },
        (error) => {
          console.error('Error executing SQL', error);
        }
      );
    })
  }

  const fetchPayments = async (n: string, date: string) => {
		DEBUG(true);
		enablePromise(true);
		const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
    (await initDB).transaction((tx) => {
			tx.executeSql(
        `SELECT After_Discount, ID,
            CASE
            WHEN Payment_Method = 'Cash' THEN 'Cash'
            WHEN Payment_Method = 'POS' THEN 'POS'
            WHEN Payment_Method = 'Bank transfer' THEN 'Bank transfer'
            ELSE NULL
         END AS Payment_Method
        FROM Sales_Record
        WHERE Payment_Method IN ('Cash', 'POS', 'Bank transfer')
          AND ${date ? date : `DATE(Date) = DATE('now', '-${n} days')`}
        ORDER BY ID;`,
        [],
        (_, results) => {
          const rows = results.rows;
          const paymentsArray: Payments[] = [];
          for (let i = 0; i < rows.length; i++) {
            paymentsArray.push(rows.item(i) as Payments);
          }
					setPaymentsData(paymentsArray);
					
          for (let i = 0; i < results.rows.length; i++) {
            const row = results.rows.item(i);
            console.log(row);
          }
        },
        (error) => {
          console.error('Error executing SQL', error);
        }
      );
    })
  }

  useEffect(() => {
		if (stopCodes) {
			try {
				fetchExpenses('0', '');
        fetchPayments('0', '');
			} catch (error) {
					console.log(error)
			}
		}
  }, [stopCodes]);

  useEffect(() => {
		if (stopCodes) {
			setAllTotal(cash + pOS + bank);
      setAllCashExpTotal(totalCash);
      setAllPOSExpTotal(totalPOS);
      setAllBankExpTotal(totalBank)
      setAllExpTotal(totalCash + totalPOS + totalBank);
      setAllCashTotal(cash - totalCash);
      setAllPOSTotal(pOS - totalPOS);
      setAllBankTotal(bank - totalBank);
      setAllAfterExpTotal((cash + pOS + bank) - (totalCash + totalPOS + totalBank));
		}
  }, [stopCodes, totalCash, totalPOS, totalBank, cash, pOS, bank]);

	useEffect(() => {
		if (stopCodes) {
      totalPaymentAndExpenses('', '', '');
		}
	}, [ stopCodes]);

  function getOrdinalSuffix(number: number): string {
    if (number >= 11 && number <= 13) {
      return number + 'th';
    } else {
      const lastDigit = number % 10;
      switch (lastDigit) {
        case 1:
          return number + 'st';
        case 2:
          return number + 'nd';
        case 3:
          return number + 'rd';
        default:
          return number + 'th';
      }
    }
  };
  
  const todayClicked = async () => {
		if (whoClicked !== 'today') {
      setPOS(0);
      setCash(0);
      setBank(0);
      setTotalBank(0);
      setTotalCash(0);
      setTotalPOS(0);
      setWhoClicked('today')
      totalPaymentAndExpenses('', '', '');
      setDateVisible(false);
      fetchExpenses('0', '');
      fetchPayments('0', '');     
    } 
	}

	const yesterdayClicked = async () => {
    if (whoClicked !== 'yesterday') {
      setPOS(0);
      setCash(0);
      setBank(0);
      setTotalBank(0);
      setTotalCash(0);
      setTotalPOS(0);
      setWhoClicked('yesterday');
      totalPaymentAndExpenses('y', '', '');
      setDateVisible(false);
      fetchExpenses('1', '');
      fetchPayments('1', '');     
    } 
	}

	const customClicked = () => {
		setWhoClicked('custom')
		setDateVisible(true)
	}

  const dateChildClicked = (day: string, month: string, monthName: string, year: string, reseter: number) => {
    if (reseter === 1) {
      totalPaymentAndExpenses('y', `${year}-${month}-${day}`, monthName);
      fetchExpenses('0', `DATE(Date) = '${year}-${month}-${day}'`); 
      fetchPayments('0', `DATE(Date) = '${year}-${month}-${day}'`); 
    }
  }

  const totalPaymentAndExpenses = async (n: string, date: string, monthName: string) => {
    setPOS(0);
    setCash(0);
    setBank(0);
    setTotalBank(0);
    setTotalCash(0);
    setTotalPOS(0);
    const compareYear = new Date().getFullYear().toString();
    const compareMonth = (new Date().getMonth() + 1).toString().padStart(2, '0');
    const compareDay = new Date().getDate().toString().padStart(2, '0');
    if (date === (`${compareYear}-${compareMonth}-${compareDay}`)) {
      setFooterText('Expenses made today so far');
    } else if (date === (`${compareYear}-${compareMonth}-${(new Date().getDate() - 1).toString().padStart(2, '0')}`)){
      setFooterText('Expenses total for yesterday')
    } else {
      date ?
      setFooterText( `Expenses total for ${getOrdinalSuffix(parseInt(date.slice(8, 10), 10))} ${monthName}, ${date.slice(0, 4)}` )
      :
      n ?
      setFooterText('Expenses total for yesterday')
      :
      setFooterText('Expenses made today so far');
    };
    console.log(date)
    console.log(`${compareYear}-${compareMonth}-${compareDay}`)
    const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
    (await initDB).transaction((tx) => {
      tx.executeSql(
        `SELECT Expenses_Type, SUM(Amount) AS Total FROM Expenses WHERE DATE(Date) = ${date ? `'${date}'` : n ? `DATE('now', '-1 days')` : `DATE('now')`} GROUP BY Expenses_Type ORDER BY Expenses_Type ASC LIMIT 3;`,
        [],
        (_, result) => {
          if (result.rows.length > 0) {
            for (let i = 0; i < result.rows.length; i++) {
              if (result.rows.item(i).Expenses_Type == 'Cash') {
                setTotalCash(result.rows.item(i).Total);
              } else if (result.rows.item(i).Expenses_Type == 'POS') {
                setTotalPOS(result.rows.item(i).Total);
              } else if (result.rows.item(i).Expenses_Type == 'Bank transfer') {
                setTotalBank(result.rows.item(i).Total);
              }
            }
          } 
        },
        (_, error) => {
          console.log('Error executing SQL', error);
        }
      );

      tx.executeSql(
        `SELECT Payment_Method, SUM(After_Discount) AS SumTotal FROM Sales_Record WHERE DATE(Date) = ${date ? `'${date}'` : n === 'y' ? `DATE('now', '-1 days')` : `DATE('now')`} GROUP BY Payment_Method ORDER BY Payment_Method;`,
        [],
        (_, result) => {
          if (result.rows.length > 0) {
            for (let i = 0; i < result.rows.length; i++) {
              if (result.rows.item(i).Payment_Method == 'Cash') {
                setCash(result.rows.item(i).SumTotal);
              } else if (result.rows.item(i).Payment_Method == 'POS') {
                setPOS(result.rows.item(i).SumTotal);
              } else if (result.rows.item(i).Payment_Method == 'Bank transfer') {
                setBank(result.rows.item(i).SumTotal);
              }
            }
          } 
        },
        (_, error) => {
          console.log('Error executing SQL', error);
        }
      );
    });
  }

  const handleCheckboxChange = async (payment: number, iD: number, ) => {
    let payMethod = '';
    if (payment === 1) {
      payMethod = 'Cash'
    } else if (payment === 2) {
      payMethod = 'POS'
    } else if (payment === 3) {
      payMethod = 'Bank transfer'
    };
    setTotalBank(0);
    setTotalCash(0);
    setTotalPOS(0);
    const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
    (await initDB).transaction((tx) => {
      tx.executeSql('UPDATE Expenses SET Expenses_Type = ? WHERE ID = ?', [payMethod, iD], (_, updateResults) => {
       
      });

      tx.executeSql(
        `SELECT Expenses_Type, SUM(Amount) AS Total FROM Expenses WHERE DATE(Date) = DATE('now') 
        GROUP BY Expenses_Type ORDER BY Expenses_Type ASC LIMIT 3;`,
        [],
        (_, result) => {
          if (result.rows.length > 0) {
            for (let i = 0; i < result.rows.length; i++) {
              if (result.rows.item(i).Expenses_Type == 'Cash') {
                setTotalCash(result.rows.item(i).Total);
              } else if (result.rows.item(i).Expenses_Type == 'POS') {
                setTotalPOS(result.rows.item(i).Total); 
              } else if (result.rows.item(i).Expenses_Type == 'Bank transfer') {
                setTotalBank(result.rows.item(i).Total);
              }
            }
          } 
        },
        (_, error) => {
          console.log('Error executing SQL', error);
        }
      );
    })
  }

  const handleAddToExpenses = async () => {
    if (expAmount.charAt(0) === '0') {
      Alert.alert ('Invalid!', 'Zero entered. You can exit the dialog if there is no expenses to enter.')
    } else if (expAmount.trim() === ''|| isNaN(parseInt(expAmount, 10))) {
      Alert.alert ('Null!', 'You have not entered an amount')
    } else if (descriptionText.trim() === '') {
      Alert.alert ('Null!', 'You must enter an expenses description')
    } else {
      DEBUG(true);
      enablePromise(true);
      const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
      (await initDB).transaction((tx) => {
        tx.executeSql(
          `INSERT INTO Expenses (Date, Description, Expenses_Type, Amount ) VALUES (DATETIME('now', '+1 hour'), ?, ?, ?);`,
          [descriptionText, checked, expAmount]
        );

        tx.executeSql(
          `SELECT Expenses_Type, SUM(Amount) AS Total FROM Expenses WHERE DATE(Date) = DATE('now') 
          GROUP BY Expenses_Type ORDER BY Expenses_Type ASC LIMIT 3;`,
          [],
          (_, result) => {
            if (result.rows.length > 0) {
              for (let i = 0; i < result.rows.length; i++) {
                if (result.rows.item(i).Expenses_Type == 'Cash') {
                  setTotalCash(result.rows.item(i).Total);
                } else if (result.rows.item(i).Expenses_Type == 'POS') {
                  setTotalPOS(result.rows.item(i).Total); 
                } else if (result.rows.item(i).Expenses_Type == 'Bank transfer') {
                  setTotalBank(result.rows.item(i).Total);
                }
              }
            } 
          },
          (_, error) => {
            console.log('Error executing SQL', error);
          }
        );

        fetchExpenses('0', '');
        setAddExpensesModal(false)
      })
  }
  };

  const deleteFromDB = async (id: number) => {
    setTotalCash(0);
    setTotalPOS(0);
    setTotalBank(0);
		DEBUG(true);
		enablePromise(true);
		const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
    (await initDB).transaction((tx) => {
			tx.executeSql(
        `DELETE FROM Expenses WHERE ID = ?;`,
        [id],
        (_, results) => {
         if (results.rowsAffected > 0) {
					console.log('Deleted Successfully')
				 }
					
        },
        (error) => {
          console.error('Error executing SQL', error);
        }
      );

      tx.executeSql(
        `SELECT Expenses_Type, SUM(Amount) AS Total FROM Expenses WHERE DATE(Date) = DATE('now') 
        GROUP BY Expenses_Type ORDER BY Expenses_Type ASC LIMIT 3;`,
        [],
        (_, result) => {
          if (result.rows.length > 0) {
            for (let i = 0; i < result.rows.length; i++) {
              if (result.rows.item(i).Expenses_Type == 'Cash') {
                setTotalCash(result.rows.item(i).Total);
              } else if (result.rows.item(i).Expenses_Type == 'POS') {
                setTotalPOS(result.rows.item(i).Total); 
              } else if (result.rows.item(i).Expenses_Type == 'Bank transfer') {
                setTotalBank(result.rows.item(i).Total);
              }
            }
          } 
        },
        (_, error) => {
          console.log('Error executing SQL', error);
        }
      );

      fetchExpenses('0', '');
    })

	};

  const handleUserChoice = (id: number) => {
    const updatedChildViews = filteredResult.filter((item) => item.ID !== id);
    setFilteredResult(updatedChildViews);
    deleteFromDB(id);
  }

  const deleteItem = (id: number) => {
    Alert.alert( 'Expenses deletion', 'Are you sure to delete this expenses?',
      [
        { text: 'Yes, Delete', onPress: () => handleUserChoice(id), isPreferred: false, style: 'default' },
        { text: 'Cancel', isPreferred: true, style: 'cancel' }
      ]
    );
  };

  return(
    <PaperProvider>
      <View>
        <View style={styles.mainView}>
          <View style={styles.headerContainer}>
            <View style={styles.textInputMasterContainer}>
              <Text style={{...styles.tabHeadText, marginHorizontal: 10, alignSelf: 'center', marginTop: -2, fontWeight: 'normal'}}>
                Displaying data from:
              </Text>
              <View style={styles.daySelect}>
                <MyButton btnText="Today"
                  btnBorClr={darkColour}
                  btnBorRadius={10}
                  btnBorWdt={2}
                  btnColor={whoClicked === 'today' ? darkColour : 'white'}
                  btnFontSize={15}
                  btnHeight={32}
                  btnWidth={95}
                  btnTxtClr={whoClicked === 'today' ? 'white' : darkColour}
                  btnPadding={4}
                  hndClicked={todayClicked}
                />
              </View>

              <View style={styles.daySelect}>
                <MyButton 
                  btnText="Yesterday" 
                  btnBorClr={darkColour}
                  btnBorRadius={10}
                  btnBorWdt={2}
                  btnColor={whoClicked === 'yesterday' ? darkColour : 'white'}
                  btnFontSize={15}
                  btnHeight={32}
                  btnWidth={95}
                  btnTxtClr={whoClicked === 'yesterday' ? 'white' : darkColour}
                  btnPadding={4}
                  hndClicked={yesterdayClicked}
                />
              </View>

              <View style={{...styles.daySelect, width:110}}>
                <MyButton 
                  btnText="Custom date" 
                  btnBorClr={darkColour}
                  btnBorRadius={10}
                  btnBorWdt={2}
                  btnColor={whoClicked === 'custom' ? darkColour : 'white'}
                  btnFontSize={15}
                  btnHeight={32}
                  btnWidth={110}
                  btnTxtClr={whoClicked === 'custom' ? 'white' : darkColour}
                  btnPadding={4}
                  hndClicked={customClicked}
                />
              </View>
            </View>
          </View>
        </View>
        <View style = {{flexDirection: 'row-reverse', marginBottom: -10}}>
        <View style = {{...styles.secondBox, width: 958, marginRight: 8, height: 50, flexDirection: 'row-reverse', 
                        justifyContent: footerText === 'Expenses made today so far' ? 'space-between' : 'flex-end'}}>
          {footerText === 'Expenses made today so far' &&
            <View style = {{marginTop: 3, marginRight: 10}}>
              <MyButton btnText= "New expenses"
                btnBorClr= 'white'
                btnBorRadius={10}
                btnColor= {darkColour}
                btnFontSize={15}
                btnHeight={40}
                btnWidth={150}
                btnTxtClr={'white'}
                btnPadding={10}
                hndClicked={()=> setAddExpensesModal(true)}
              />
            </View>
          }
          <View style = {{marginLeft: 10, alignSelf: 'center'}}>
            <Text style={styles.tabHeadText}>Expenses Tab</Text>
          </View>
        </View>

        <View style = {{...styles.secondBox, marginRight: 0, width: 597, height: 50, flexDirection: 'row'}}>
        <View style = {{marginLeft: 10, alignSelf: 'center'}}>
            <Text style={styles.tabHeadText}>Sales per payment type</Text>
          </View>
        </View>
        
        </View>
        <View style = {{ flexDirection: 'row'}}>
          <View style = {styles.firstBox}>
            <View style={styles.firstBoxHeader}>
              <View style={{ ...styles.columnHeaderBox, width: 198, marginLeft: 0, borderLeftWidth: 0 }}>
                <Text style={{ ...styles.columnHeaderText }}>Cash Payments(₦)</Text>
              </View>
              <View style={{ ...styles.columnHeaderBox, width: 200 }}>
                <Text style={{ ...styles.columnHeaderText }}>POS Payments(₦)</Text>
              </View>
              <View style={{ ...styles.columnHeaderBox, width: 198, borderRightWidth: 0 }}>
                <Text style={{ ...styles.columnHeaderText }}>Bank Transfer Payment(₦)</Text>
              </View>
            </View>

            <View style = {{ width: '100%', height: 550, backgroundColor:'white',}}>
              <ScrollView>
                {paymentsData.map((data, index) => (
                  <ExpensesChild
                    key={data.ID}
                    texts={[
                      Number(data.After_Discount?.toString()).toLocaleString('en-NG'), 
                      Number(data.After_Discount?.toString()).toLocaleString('en-NG'), 
                      Number(data.After_Discount?.toString()).toLocaleString('en-NG')]}
                    onCheckboxChange={() => {}}
                    index={index}
                    isExpenses= {false}
                    showCheckBox= {false}
                    id={data.ID}
                    type= {data.Payment_Method}
                    delPressed={() => {}}
                  />
                ))}
              </ScrollView>
            </View>

            <View style = {styles.secondBoxFooterText}>
              <View style = {{...styles.secondBoxFooterTotal, width: 200}}>
                <Text style={{ ...styles.columnHeaderText, marginTop: 0, alignSelf: 'center'}}>
                {Number(cash).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                </Text>
              </View>
              <View style = {{...styles.secondBoxFooterTotal, width: 200}}>
                <Text style={{ ...styles.columnHeaderText, marginTop: 0, alignSelf: 'center'}}>
                {Number(pOS).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                </Text>
              </View>
              <View style = {{...styles.secondBoxFooterTotal, width: 200}}>
                <Text style={{ ...styles.columnHeaderText, marginTop: 0, alignSelf: 'center'}}>
                {Number(bank).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                </Text>
              </View>
            </View>
          </View>

          <View style = {{marginLeft: -10}}>
            <View style = {styles.secondBox}>
              <View style={styles.secondBoxHeader}>
                <View style={{ ...styles.columnHeaderBox, width: 485, marginLeft: 0, borderLeftWidth: 0 }}>
                  <Text style={{ ...styles.columnHeaderText }}>Expenses made</Text>
                </View>
                <View style={{ ...styles.columnHeaderBox, width: 150}}>
                  <Text style={{ ...styles.columnHeaderText }}>Cash(₦)</Text>
                </View>
                <View style={{ ...styles.columnHeaderBox, width: 150 }}>
                  <Text style={{ ...styles.columnHeaderText }}>POS(₦)</Text>
                </View>
                <View style={{ ...styles.columnHeaderBox, width: 150 }}>
                  <Text style={{ ...styles.columnHeaderText }}>Bank Transfer(₦)</Text>
                </View>
              </View>
              <View style = {{ width: '100%', height: 288, backgroundColor:'white',}}>
              <ScrollView>
              {filteredResult.map((data, index) => (
                  <ExpensesChild
                    key={data.ID}
                    texts={[data.Description, 
                      Number(data.Amount?.toString()).toLocaleString('en-NG'),
                      Number(data.Amount?.toString()).toLocaleString('en-NG'),
                      Number(data.Amount?.toString()).toLocaleString('en-NG')]}
                    onCheckboxChange={(payment) => handleCheckboxChange(payment, data.ID)}
                    index={index}
                    isExpenses= {true}
                    showCheckBox = {footerText === 'Expenses made today so far' ? true : false}
                    id={data.ID}
                    type= {data.Expenses_Type}
                    delPressed={() => deleteItem(data.ID)}
                  />
                ))}
              </ScrollView>
              </View>
              <View style = {styles.secondBoxFooterText}>
                <Text style={{ ...styles.columnHeaderText, marginTop: 0, alignSelf: 'center', width: 357 }}>
                  {footerText}
                </Text>
                <IconButton
                      icon="ray-start-arrow"
                      iconColor= 'white'
                      size={40}
                      focusable={false}
                      style={{marginRight:90, marginLeft: -20, marginTop:-8}}
                    />
                <View style = { styles.secondBoxFooterTotal}>
                  <Text style={{ ...styles.columnHeaderText, marginTop: 0, alignSelf: 'center'}}>
                  {Number(totalCash).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                  </Text>
                </View>
                <View style = { styles.secondBoxFooterTotal}>
                  <Text style={{ ...styles.columnHeaderText, marginTop: 0, alignSelf: 'center'}}>
                  {Number(totalPOS).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                  </Text>
                </View>
                <View style = { styles.secondBoxFooterTotal}>
                  <Text style={{ ...styles.columnHeaderText, marginTop: 0, alignSelf: 'center'}}>
                  {Number(totalBank).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                  </Text>
                </View>
              </View>
            </View>
            {dateVisible &&
            <View style={{marginTop:-60, marginLeft:50, top:-52, left: -75, position: 'absolute'}}>
              <SingleDayDateSelect appearUp ={false} onError={false} onNewDateSelected={dateChildClicked}/>
            </View> 
            }

            <Portal>
              <Modal visible = {addExpensesModal} contentContainerStyle={{width:500, height: 280, backgroundColor:'white', borderWidth:2, borderColor:darkColour, borderRadius:10, marginTop: -250, marginLeft:1080}} onDismiss={()=> setAddExpensesModal(false)}>
                <View style={{paddingVertical:5}}>
                  <View style={{width:500, paddingHorizontal:3, flexDirection:'row'}}>
                    <TextInputTemp refObject={qtyRef} lTxt="Amount(₦)" plhrTxt="Enter amount" cnWidth={220} 
                      txtWidth={118} lbWidth={100} makeDigits ={true} onChangeText={(amt)=>setExpAmount(amt)} 
                      enterKeyIsSunmit = {true} onSubmit={handleAddToExpenses}
                    />
                    <View style={{flex: 1, height:40, justifyContent:'flex-end', alignItems:'center' , marginTop:10, paddingHorizontal:4, flexDirection:'row'}}>
                      <View>
                        <MyButton btnText='Add' btnWidth={60} hndClicked={handleAddToExpenses} />
                      </View>
                    
                      <IconButton icon="close-box" iconColor={darkColour} size={30} style={{width:45, height:45, margin:0, padding:2}} 
                        containerColor={'transparent'} focusable={true} onPress={()=> setAddExpensesModal(false)}
                      />
                    </View>
                  </View>

                  <View style={{alignSelf:'center'}}>
                    <ReactText
                      placeholder= 'Expenses description'
                      multiline
                      numberOfLines={4}
                      spellCheck ={false}
                      style={styles.notesText}
                      onChangeText={(text)=> setDescriptionText(text)}
                    />
                  </View>

                  <View>
                    <Text style = {{...styles.thirdBoxText, marginLeft: 15, fontFamily: 'Arial'}}>
                      Expenses made from?
                    </Text>
                    <View style = {{flexDirection: 'row', borderWidth: 2, borderRadius: 10, marginHorizontal: 15, marginBottom: 10}}>
                      <View style = {{flexDirection: 'row', marginRight: 10}}>
                        <Checkbox
                          status={ checked === 'Cash' ? 'checked' : 'unchecked' }
                          color= {darkColour}
                          onPress={() => setChecked('Cash')}
                        />
                        <Text style = {{alignSelf: 'center', marginLeft: -5}}>
                          Cash lodgement
                        </Text>
                      </View>
                    
                      <View style = {{flexDirection: 'row', marginRight: 10}}>
                        <Checkbox
                          status={ checked === 'POS' ? 'checked' : 'unchecked' }
                          color= {darkColour}
                          onPress={() => setChecked('POS')}
                        />
                        <Text style = {{alignSelf: 'center', marginLeft: -5}}>
                          POS lodgement
                        </Text>
                      </View>

                      <View style = {{flexDirection: 'row', marginRight: 10}}>
                        <Checkbox
                          status={ checked === 'Bank transfer' ? 'checked' : 'unchecked' }
                          color= {darkColour}
                          onPress={() => setChecked('Bank transfer')}
                        />
                        <Text style = {{alignSelf: 'center', marginLeft: -5}}>
                          Bank trasfer lodgement
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
              </Modal>
            </Portal>

            <View style = {{...styles.secondBox, width: 960, height: 241}}>
              <View style = {styles.thirdBoxChildren}>
                <Text style={styles.thirdBoxText}>Total sales revenue made for this day: </Text>
                <Text style={{...styles.thirdBoxAmountText, marginRight: 0}}>
                  {Number(allTotal).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                </Text>
              </View>

              <View style = {{...styles.thirdBoxChildren, paddingLeft: 100, borderWidth: 0}}>
                <Text style={styles.thirdBoxText}>Daily expenses made from cash lodgement: </Text>
                <Text style={styles.thirdBoxAmountText}>
                  {Number(allCashExpTotal).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                </Text>
              </View>
              <View style = {{...styles.thirdBoxChildren, paddingLeft: 100, borderWidth: 0}}>
                <Text style={styles.thirdBoxText}>Daily expenses made from POS lodgement: </Text>
                <Text style={styles.thirdBoxAmountText}>
                  {Number(allPOSExpTotal).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                </Text>
              </View>
              <View style = {{...styles.thirdBoxChildren, paddingLeft: 100, borderWidth: 0}}>
                <Text style={styles.thirdBoxText}>Daily expenses made from Bank transfer lodgement: </Text>
                <Text style={styles.thirdBoxAmountText}>
                  {Number(allBankExpTotal).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                </Text>
              </View>

              <View style = {styles.thirdBoxChildren}>
                <Text style={styles.thirdBoxText}>Total Daily expenses made : </Text>
                <Text style={{...styles.thirdBoxAmountText, marginRight: 0}}>
                  {Number(allExpTotal).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                </Text>
              </View>

              <View style = {{...styles.thirdBoxChildren, paddingLeft: 100, borderWidth: 0}}>
                <Text style={styles.thirdBoxText}>Cash lodgement after expenses deduction: </Text>
                <Text style={styles.thirdBoxAmountText}>
                  {Number(allCashTotal).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                </Text>
              </View>
              <View style = {{...styles.thirdBoxChildren, paddingLeft: 100, borderWidth: 0}}>
                <Text style={styles.thirdBoxText}>POS lodgement after expenses deduction: </Text>
                <Text style={styles.thirdBoxAmountText}>
                  {Number(allPOSTotal).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                </Text>
              </View>
              <View style = {{...styles.thirdBoxChildren, paddingLeft: 100, borderWidth: 0}}>
                <Text style={styles.thirdBoxText}>Bank transfer lodgement after expenses deduction: </Text>
                <Text style={styles.thirdBoxAmountText}>
                  {Number(allBankTotal).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                </Text>
              </View>

              <View style = {styles.thirdBoxChildren}>
                <Text style={styles.thirdBoxText}>Total revenue after daily expenditure: </Text>
                <Text style={{...styles.thirdBoxAmountText, marginRight: 0}}>
                  {Number(allAfterExpTotal).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </View>
    </PaperProvider>
  );
}

const styles = StyleSheet.create ({
  firstBox: {
    width: 597, 
    height:630, 
    backgroundColor:'white', 
    borderRadius:10, 
    borderWidth:2, 
    borderBottomWidth:2, 
    borderLeftWidth:2, 
    borderColor:'#DCE3E8',
    margin:10,
    alignContent:'center'
  },
  secondBox: {
    width: 960, 
    height:368,
    backgroundColor:'white', 
    borderRadius:10, 
    borderWidth:2, 
    borderBottomWidth:2, 
    borderLeftWidth:2, 
    borderColor:'#DCE3E8',
    margin:10,
    alignContent:'center'
  },
  firstBoxHeader: {
		width: 593,
		height: 35,
		backgroundColor: darkColour,
		flexDirection: 'row',
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10,
	},
  secondBoxHeader: {
		width: 956,
		height: 35,
		backgroundColor: darkColour,
		flexDirection: 'row',
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10,
	},
  columnHeaderBox: {
		borderWidth:2, 
		borderColor:'black', 
		width:57,  
		height:35, 
		alignItems:'center',
		marginLeft:-2,
		borderTopWidth:0,
	},
  columnHeaderText: {
    fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'normal', 
    textAlign:'center',
    color:'white', 
    marginTop:6
    },
  tabHeadText: {
    fontFamily:'century gothic', 
    fontSize:17, 
    fontWeight:'bold', 
    textAlign:'center',
    color: darkColour, 
    marginTop:0
  },
  thirdBoxChildren: {
    flexDirection: 'row', 
    paddingHorizontal:10, 
    justifyContent: 'space-between', 
    borderWidth: 2, 
    borderColor: darkColour, 
    borderLeftWidth: 0, 
    borderRightWidth: 0,
  },
  deleteContainer: {
    flex:1, 
    backgroundColor:'white', 
    alignSelf:'center', 
    paddingRight:20
  },
  dateContainer: {
    marginTop:-60, 
    marginLeft:50, 
    top:72, 
    left: 880, 
    position: 'absolute'
  },
  headerContainer: {
    flexDirection:'column', 
    backgroundColor:'white', 
    alignSelf:'center', 
    borderWidth:2, 
    borderColor: '#DCE3E8', 
    borderRadius:10, 
    marginLeft:10, 
    marginTop:10, 
    marginBottom:10, 
    width:540, 
    height:40,
  },
  daySelect: {
    alignSelf:'center', 
    marginLeft:-2, 
    height:40, 
    width:95,
    borderWidth:2, 
    borderColor: 'transparent', 
    borderTopRightRadius:10,
    borderBottomRightRadius:10, 
    marginRight:10, 
    borderLeftWidth:0, 
    marginTop:0, 
    alignContent:'center'
  },
  textInputMasterContainer: {
    flexDirection:'row', 
    width:634, 
    height:40
  },
  mainView: {
    flexDirection: 'row', 
    backgroundColor: 'white', 
    borderWidth: 2, 
    borderRadius: 10, 
    marginLeft: 20, 
    marginRight: 20, 
    borderColor: '#DCE3E8',
  },
  mainDataView: {
		flex:1, 
		height:500, 
		borderWidth:2, 
		borderBottomWidth:0,
		borderColor:'#DCE3E8', 
		marginTop:10, 
		marginBottom:0, 
		borderRadius:10,
		borderBottomLeftRadius:0,
		borderBottomRightRadius:0,
		marginLeft:20, 
		marginRight:20, 
		backgroundColor:'white'
	},
  secondBoxFooterTotal: {
    width: 150, 
    borderWidth: 2, 
    borderColor: 'white', 
    marginLeft: -2, 
    borderTopWidth: 0, 
    borderBottomWidth: 0, 
    justifyContent: 'center'
  },
  secondBoxFooterText: {
    width: '100%', 
    height: 40, 
    flexDirection: 'row', 
    backgroundColor: darkColour, 
    borderBottomRightRadius: 10, 
    borderBottomLeftRadius: 10, 
    justifyContent: 'flex-start'
  },
  thirdBoxText: {
    fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'normal', 
    textAlign:'left',
    alignSelf: 'flex-start',
    color: darkColour, 
    margin:3,
    },
    thirdBoxAmountText: {
      fontFamily:'century gothic', 
      fontSize:15, 
      fontWeight:'600', 
      textAlign:'left',
      alignSelf: 'flex-start',
      color: darkColour, 
      margin:3,
      marginRight: 300
      },
    viewStyle: {
      borderWidth: 2, 
      borderColor: 'black', 
      height: 35, 
      alignItems: 'center', 
      marginLeft: -2, 
      borderTopWidth: 0, 
      borderBottomWidth: 0,
    },
    paymentCheckBox: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      borderWidth: 2, 
      borderColor: 'black', 
      height: 35, 
      alignItems: 'center', 
      marginLeft: -2, 
      borderTopWidth: 0, 
      borderBottomWidth: 0,
    },
    textStyle: {
      color: darkColour,
      fontFamily: 'century gothic', 
      fontSize: 15, 
      fontWeight: 'normal',
      marginTop: 6,
    },
    childPressable: {
      flexDirection: 'row',
      alignItems: 'center',
      height: 35,
      borderColor: 'black',
      borderTopWidth: 2,
      borderBottomWidth: 2,
      marginTop: -2,
    },
    notesText: {
      borderWidth: 1,
      borderRadius:10,
      borderColor: '#DCE3E8',
      width:400,
      height:110,
      padding:10,
      paddingBottom:5,
      color:'black', 
      fontFamily:'century gothic', 
      fontSize:16, 
      fontWeight:'300',
      marginBottom:10,
      marginHorizontal:0,
      alignSelf:'center'
    },
})

export default TotalAndExpenses;